// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import HelpOutlinedSvg from "@fishx/icons-svg/es/asn/HelpOutlined";
import FishxIcon from '../components/FishxIcon';

var HelpOutlined = function HelpOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: HelpOutlinedSvg
  }));
};

HelpOutlined.displayName = 'HelpOutlined';
export default React.forwardRef(HelpOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/HelpOutlined.js
// module id = 2926
// module chunks = 0